import { computeHours } from '~/utils/shiftCard';

/**
 * Duration in the Counter Adjustment panel's wording, e.g. "7.5 hours".
 *
 * `computeHours` renders the abbreviated "7.5 hrs" the shift cards use; the
 * design spells it out here because the value sits inside a sentence-like
 * parenthetical rather than in a dense card slot.
 */
export const formatCounterDuration = (start?: string, end?: string): string | undefined => {
  const abbreviated = computeHours(start, end);

  return abbreviated?.replace(/\bhrs?\b/, (match) => (match === 'hr' ? 'hour' : 'hours'));
};

/** A time range without its duration, e.g. "8:30 AM - 4:00 PM". */
export const formatCounterRange = (start?: string, end?: string): string =>
  `${(start ?? '').toUpperCase()} - ${(end ?? '').toUpperCase()}`;
